export const isInRole = (userRoles: string[], role: string) => {
	return userRoles.findIndex((r) => r === role) >= 0;
};
